"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeamSnapshot = void 0;
const memoizee_1 = __importDefault(require("memoizee"));
const AggregatedBudget_1 = require("./AggregatedBudget");
const Capacity_1 = require("./Capacity");
const DateDTO_1 = require("./DateDTO");
const Identifiable_1 = require("./Identifiable");
const RegionHandle_1 = require("./RegionHandle");
const DEFAULT_REGION = new RegionHandle_1.RegionHandle({ id: "", name: "", holidays: [] });
class TeamSnapshot {
    constructor(year, month, team, allEngineers, allCustomers, regions) {
        this.year = year;
        this.month = month;
        this.team = team;
        this.regions = regions;
        this.getDate = (0, memoizee_1.default)(() => new Date(this.year, this.month));
        this.engineers = allEngineers.filter((e) => e.isInTeam(this.team.id, this.year, this.month));
        this.engineersMap = (0, Identifiable_1.toIdentifiableMap)(this.engineers);
        this.customers = allCustomers.filter((c) => c.isInTeam(this.year, this.month, this.team.id));
        this.customersMap = (0, Identifiable_1.toIdentifiableMap)(this.customers);
    }
    getId() {
        return this.team.id;
    }
    getBudget() {
        return this.customers
            .filter((customer) => customer.isInTeam(this.year, this.month, this.team.id))
            .reduce((acc, c) => {
            acc.add(c.id, c.getBudget(this.year, this.month));
            return acc;
        }, new AggregatedBudget_1.AggregatedBudget());
    }
    getTimeOfffHours() {
        return this.engineers.reduce((acc, engineer) => {
            let total = acc;
            const region = this.regions[engineer.region] || DEFAULT_REGION;
            const capacity = new Capacity_1.Capacity(this.year, this.month, engineer, region);
            const utilization = capacity.getTeamUtilization(this.team.id);
            const hours = utilization.getTimeOffHours();
            total += hours;
            return total;
        }, 0);
    }
    getGrossUtilizationHours() {
        return this.engineers.reduce((acc, engineer) => {
            let total = acc;
            const region = this.regions[engineer.region] || DEFAULT_REGION;
            const capacity = new Capacity_1.Capacity(this.year, this.month, engineer, region);
            const utilization = capacity.getTeamUtilization(this.team.id);
            const hours = utilization.getGrossUtilizationHours();
            total += hours;
            return total;
        }, 0);
    }
    getUtilizationHours() {
        return this.engineers.reduce((acc, engineer) => {
            let total = acc;
            const region = this.regions[engineer.region] || DEFAULT_REGION;
            const capacity = new Capacity_1.Capacity(this.year, this.month, engineer, region);
            const utilization = capacity.getTeamUtilization(this.team.id);
            const hours = utilization.getUtilizationHours();
            total += hours;
            return total;
        }, 0);
    }
    getUtilizationHours1850() {
        return this.engineers.reduce((acc, engineer) => {
            let total = acc;
            const region = this.regions[engineer.region] || DEFAULT_REGION;
            const capacity = new Capacity_1.Capacity(this.year, this.month, engineer, region);
            const utilization = capacity.getTeamUtilization(this.team.id);
            const hours = utilization.getUtilizationHours1850();
            total += hours;
            return total;
        }, 0);
    }
    hasHarvestHours() {
        const key = (0, DateDTO_1.serializeMonthDTO)(this.year, this.month);
        return !!this.team.harvestHours[key];
    }
    getHarvestHours() {
        const key = (0, DateDTO_1.serializeMonthDTO)(this.year, this.month);
        const map = this.team.harvestHours || {};
        return map[key] || { total: 0, billable: 0, budgeted: 0 };
    }
    hasEngineer(id) {
        return !!this.engineersMap[id];
    }
    hasCustomer(id) {
        return !!this.customersMap[id];
    }
    countCustomerOffboardings() {
        return this.customers.reduce((acc, customer) => {
            const offboardedDate = customer.getOffboardingDate();
            return offboardedDate &&
                offboardedDate.getFullYear() == this.year &&
                offboardedDate.getMonth() === this.month
                ? acc + 1
                : acc;
        }, 0);
    }
    isOverCapacity() {
        const budget = this.getBudget()?.getPlannedHours() || 0;
        const capacity = this.getGrossUtilizationHours() || 0;
        return budget > capacity;
    }
    getGrossDelta() {
        const budget = this.getBudget()?.getPlannedHours() || 0;
        const capacity = this.getGrossUtilizationHours() || 0;
        return capacity - budget;
    }
}
exports.TeamSnapshot = TeamSnapshot;
//# sourceMappingURL=TeamSnapshot.js.map